import React from 'react';
import PropTypes from 'prop-types';

import {
  Dropdown,
  DropdownTarget,
  DropdownSource,
  DropdownContext,
  DropdownMenu,
  DropdownMenuItem,
  DropdownContent
} from '@brandwatch/axiom-components';

import SlidePickerFilterInput from './SlidePickerFilterInput';
import SlidePickerMenuItem from './SlidePickerMenuItem';
import useDeferredFocus from './useDeferredFocus';

const SlidePickerDropdown = ({
  children,
  slideIndex,
  filteredSlides = [],
  filterValue = '',
  onItemClick,
  onFilterChange,
  onOpen,
  onClose
}) => {
  const inputBind = useDeferredFocus();

  return (
    <Dropdown
      onRequestOpen={onOpen}
      onRequestClose={onClose}
      withMask={true}
    >
      <DropdownTarget>
        {children({})}
      </DropdownTarget>
      <DropdownSource>
        <DropdownContext>
          <DropdownContent hasFullSeparator={true}>
            <SlidePickerFilterInput
              value={filterValue}
              onChange={onFilterChange}
              onInputNode={inputBind}
            />
          </DropdownContent>
          <DropdownMenu
            hasFullSeparator={true}
            maxHeight="calc(var(--spacing-grid-size--x1) * 92)"
          >
            {filteredSlides.map((slide) => {
              return (
                <SlidePickerMenuItem
                  key={slide.index}
                  Component={DropdownMenuItem}
                  index={slide.index}
                  label={slide.name}
                  isActive={slideIndex === slide.index}
                  onClick={onItemClick}
                />
              );
            })}
          </DropdownMenu>
        </DropdownContext>
      </DropdownSource>
    </Dropdown>
  );
};

SlidePickerDropdown.propTypes = {
  children: PropTypes.func.isRequired,
  slideIndex: PropTypes.number,
  filteredSlides: PropTypes.array,
  filterValue: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired
};

export default SlidePickerDropdown;
